export type QuantileResult = {
  quantile: number;
  index: number;
  value: number;
};

const setOnePriceForAllBoundaries = (
  sortedPriceArr: number[],
  quantileArr: number[],
): QuantileResult[] =>
  quantileArr.map((quantile) => ({
    quantile,
    index: 0,
    value: sortedPriceArr[0],
  }));

const setRespectivePriceForEachBoundary = (
  sortedPriceArr: number[],
  quantileArr: number[],
): QuantileResult[] =>
  quantileArr.map((quantile, index) => ({
    quantile,
    index,
    value: sortedPriceArr[index],
  }));

const setCalculatedBoundaries = (
  sortedPriceArr: number[],
  quantileArr: number[],
): QuantileResult[] =>
  quantileArr.map((quantile) => {
    const position = Math.floor(sortedPriceArr.length * quantile - 1.00001) + 1;
    return {
      quantile,
      index: position,
      value: sortedPriceArr[position],
    };
  });

const quantileCalculator = (
  sortedPriceArr: number[],
  quantileArr: number[],
): QuantileResult[] => {
  if (!sortedPriceArr || !sortedPriceArr.length) {
    return [];
  }

  if (sortedPriceArr.length === 1) {
    return setOnePriceForAllBoundaries(sortedPriceArr, quantileArr);
  }

  if (sortedPriceArr.length <= quantileArr.length + 1) {
    return setRespectivePriceForEachBoundary(sortedPriceArr, quantileArr);
  }

  return setCalculatedBoundaries(sortedPriceArr, quantileArr);
};

export default quantileCalculator;
